import { MessageType, type BarSlot } from "odyssey-shared";

/**
 * The server's `bar` (P2.8-T29, ADR-121 decision 5.1, PROTOCOL.md 6.51.0) as the page's bar takes it. The text schema
 * has already checked every field when a message reaches here, so nothing is checked twice.
 */

/**
 * A `bar`: the set it answers, 0 for a join's, and the ten slots, or null for the default bar.
 */
export interface BarEvent {
  readonly seq: number;
  readonly slots: readonly BarSlot[] | null;
}

/**
 * A `bar` as the page's bar takes it, or null for any other message.
 *
 * @param message A parsed server message.
 * @returns The event, or null.
 * @example
 * readBar({ type: MessageType.Bar, seq: 0, slots: null });
 * // { seq: 0, slots: null }
 */
export function readBar(message: Readonly<Record<string, unknown>> & { readonly type: number }): BarEvent | null {
  if (message.type !== MessageType.Bar) {
    return null;
  }
  return { seq: message["seq"] as number, slots: message["slots"] as readonly BarSlot[] | null };
}
